/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";
// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "./DefaultCounterCard";
/* eslint-disable react/prop-types */
// eslint-disable-next-line
const Counters = ({ selectedKunta, setSelectedKunta }) => {
  const [t] = useTranslation("common");
  //console.log(selectedKunta);
  //console.log(setSelectedKunta);
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={308}
              suffix=""
              title={t("common.municipalsinfinland")}
              description={t("common.counterstext")}
            />
          </Grid>
          <Grid item xs={12} md={4} display="flex">
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
            <DefaultCounterCard
              count={18135}
              suffix=""
              title={t("common.personsaverage")}
              description={t("common.municipalpersons")}
              color="black"
            />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, ml: 0 }} />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={100}
              suffix="+"
              title={t("common.casesyear")}
              description={t("common.casesyeartext")}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
};

export default Counters;
